import { ACCESS_TOKEN } from "./constants";

export const request = (options, state) => {
    const headers = new Headers({
        "Content-Type": "application/json",
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append(
            "Authorization",
            "Bearer " + localStorage.getItem(ACCESS_TOKEN)
        );
    }

    const defaults = { headers: headers };
    options = Object.assign({}, defaults, options);

    const controller = new AbortController();
    options.signal = controller.signal;

    const timeout = 50000; // 30 segundos de timeout

    const fetchPromise = fetch(options.url, options)
        .then((response) => response.json())
        .then((json) => {
            if (json.status === 401) {
                localStorage.removeItem(ACCESS_TOKEN);
                return {
                    ...json,
                    error: true,
                    process: 'failed',
                    content: []
                };
            }
            return { error: false, ...json };
        });

    const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
            controller.abort();
            reject(new Error('Request timed out'));
        }, timeout);
    });

    return Promise.race([fetchPromise, timeoutPromise]);
};
